/**
 * Get the selected filters from the current page or previous state (local storage or URL).
 * 
 * @returns {Array} The selected filters
 */
export default () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';
  let selected_filtering = [];

  /*
  // For the PLP only, we check if we have a previous state saved (coming back from PDP) or URL filters
  if (!from_search) {
    // Retrieve the filter state when coming back from PDP using the data saved in localStorage
    const previous_state = (with_previous_state) ? previousStateLocalStorage() : null;
    if (previous_state !== null) {
      return convertelectedFiltersToNostoFormat(previous_state.saved_filters);
    }

    // Retrieve the filter state from the Query Params in the URL if any
    if (with_previous_state) {
      const url_filters_and_sorting = getURLFiltersAndSorting();
      if (url_filters_and_sorting !== null) {
        selected_filtering = convertelectedFiltersToNostoFormat(url_filters_and_sorting);
        if (selected_filtering.length > 0) {
          return selected_filtering;
        }
      }
    }
  }
  */

  // Get the selected filters from the current page for either PLP or search overlay
  document.querySelectorAll(`[data-${prefix}filter-options]`).forEach(option => {
    const active_options = option.querySelectorAll('[data-clickable-option].active');

    if (active_options.length) {
      const group_type = (from_search) ? option.dataset.overlaySearchFilterOptionsType : option.dataset.filterOptionsType;

      active_options.forEach(active_option => {
        selected_filtering.push([
          group_type,
          active_option.dataset.optionValue
        ]);
      });
    }
  });

  // Remove duplicates due to desktop/mobile filters
  // selected_filtering = _.uniqWith(selected_filtering, _.isEqual);
  selected_filtering = Array.from(
    new Set(selected_filtering.map(JSON.stringify))
  ).map(JSON.parse);

  // selected_filtering_names = _.uniqWith(selected_filtering_names, _.isEqual);

  // Third level URL tag - /collections/whats-new/blue
  // if (!from_search) {
  //   const custom_filter_color = window.localStorage.getItem('wild-third-level-url');
  //   if (custom_filter_color !== '' && custom_filter_color !== null) {
  //     // selected_filtering.push(['options.color', custom_filter_color]);
  //     const all_color_filters = custom_filter_color.split(',');
  //     for (let i = 0; i < all_color_filters.length; i++) {
  //       selected_filtering.push(['skus.customFields.astr-color_family', all_color_filters[i]]);
  //     }
  //   }
  // }

  console.log('[ASTR] 3 - selected_filtering', from_search, selected_filtering);

  return selected_filtering;
};
